import React, { useEffect } from 'react'
import { SlLocationPin } from "react-icons/sl";
import { LiaPhoneSolid } from "react-icons/lia";



const Modal2Table = ({data}) => {

  useEffect(() => {
    // console.log(data, 'SCHOOL DATA')
  },[data])

  return (
    <div className='flex flex-col items-center justify-start w-full my-5 md:my-2 lg:my-3 xl:my-4'>
    
       <div className="overflow-x-auto w-full h-full no-scrollbar">
                <table className="table-auto border-collapse w-full rounded-lg border-none">
                <thead className=''>
                  <tr className='w-full rounded-lg'>
                    <th className="px-4 pt-[10px] text-[11px] font-normal text-start text-[#808080] md:pt-3 md:text-xs lg:pt-3 lg:font-medium xl:px-8 xl:py-4 xl:text-sm">
                        <p className='w-[20px] md:w-[40px]'>
                           S/N
                        </p>
                    </th>

                    <th className="px-4 pt-[10px] text-[11px] font-normal text-start text-[#808080] md:pt-3 md:text-xs lg:pt-3 lg:font-medium xl:px-8 xl:py-4 xl:text-sm">
                      <p className='w-[75px] md:w-[100px] xl:w-[110px]'>
                          Institution name (abbreviations)
                      </p>
                    </th>

                    <th className="px-4 pt-[10px] text-[11px] font-normal text-start text-[#808080] md:pt-3 md:text-xs lg:pt-3 lg:font-medium xl:px-8 xl:py-4 xl:text-sm">
                      <p className='w-[100px] md:w-[125px]'>
                           Name of institutions
                      </p>
                    </th>

                    <th className="px-4 pt-[10px] text-[11px] font-normal text-start text-[#808080] md:pt-3 md:text-xs lg:pt-3 lg:font-medium xl:px-8 xl:py-4 xl:text-sm">
                      <p className='w-[100px] md:w-[150px]'>
                          Contact institutions
                      </p>
                    </th>

                  </tr>
                </thead>

                {data.map((item, index) => (
                <tbody key={index} className='w-full'>
                  <tr className='w-full bg-white'>
                    <td className="px-4 py-2 border-t-[1px] border-[#DDE1E6] text-[10px] font-normal text-[#53545C] md:text-[11px] md:py-2 lg:py-3 lg:text-xs xl:px-8 xl:py-3 xl:text-sm">{index + 1}</td>
                    <td className="px-4 py-2 border-t-[1px] border-[#DDE1E6] text-[10px] font-normal text-[#53545C] md:text-[11px] md:py-2 lg:py-3 lg:text-xs xl:px-8 xl:py-3 xl:text-sm">{item.abbreviation}</td>
                    <td className="px-4 py-2 border-t-[1px] border-[#DDE1E6] text-[10px] font-normal text-[#53545C] md:text-[11px] md:py-2 lg:py-3 lg:text-xs xl:px-8 xl:py-3 xl:text-sm">{item.instName}</td>
                    <td className="px-4 py-2 border-t-[1px] border-[#DDE1E6] text-[10px] font-normal text-[#53545C] md:text-[11px] md:py-2 lg:py-3 lg:text-xs xl:px-8 xl:py-3 xl:text-sm">
                        <div className='flex flex-col items-start w-full'>
                            <div  className='flex items-start justify-start w-full'>
                               {item.instAddress && <SlLocationPin className='text-xs lg:text-sm xl:text-base' />}
                               <p className='text-[#53545C] text-[10px] font-normal ml-1.5 w-[80%] md:text-[11px] md:w-[85%] lg:text-xs xl:text-sm'>
                                    {item.instAddress}
                               </p>
                            </div>

                            {item.instPhone.map((item, index) => (
                            item !== '' &&
                            <div key={index} className='flex items-start justify-start w-full mt-[5px] md:mt-2 lg:mt-[10px]'>
                               <LiaPhoneSolid className='text-sm lg:text-base xl:text-lg' />
                                <div className='flex flex-row w-full items-start'>
                                   <p className='text-[#53545C] text-[10px] font-normal ml-1.5 md:text-[11px] lg:text-xs xl:text-sm'>
                                       {item}
                                   </p>
                                </div>
                            </div>
                            ))}
                        </div>
                    </td>
                  </tr>
                  
                </tbody>
                    )
                )} 

              </table>
         </div>

    </div>
  )
}

export default Modal2Table
